module.exports = __webpack_public_path__ + "img/benefit_img.de173fa3.png";